import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/terminales-de-netpay/';

/**
 * GET Terminales de NetPay
 * @returns {Promise<Array<object>>}
 */
export const getTerminalesDeNetPay = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Terminal de NetPay
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTerminalDeNetPay = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Terminal de NetPay
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTerminalDeNetPay = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Terminal de NetPay
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTerminalDeNetPay = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Terminal de NetPay
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTerminalDeNetPay = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
